var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component mt-3 px-4"},[_c('div',{staticClass:"card bg-white border-0 rounded-0"},[_c('div',{staticClass:"card-body"},[_c('h1',{domProps:{"textContent":_vm._s(_vm.$ml.get('mycommentedentries_title'))}}),_c('entry-table',{attrs:{"items":this.g_entries_my_approved}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }